import styled from 'styled-components';

export const _Container = styled.section`
  display: flex !important; //!important is needed to override bootstrap styling in skbv-frontend
  flex-direction: ${(props) => props.flexDirection};
  flex-grow: 1;
  flex-shrink: 1;
  flex-basis: ${(props) => (props.width ? props.width : '100%')};
  min-width: ${(props) => (props.width ? props.width : 'unset')}; //Needed as min-width is set to 100% in skbv-frontend
  margin: ${(props) => (props.width ? '0 auto' : '0')};
  align-items: ${(props) => props.alignItems || 'baseline'};
  justify-content: ${(props) => props.justifyContent || 'baseline'};
`;
